/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CnPricing.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuCn from "../../assets/component/HomepageMenuCn/HomepageMenuCn.js";

class CnPricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      isCompareExpanded: true,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleToggleComparison = this.handleToggleComparison.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  handleToggleComparison() {
    this.setState((prevState) => ({
      isCompareExpanded: !prevState.isCompareExpanded,
    }));
  }

  render() {
    const { isCompareExpanded } = this.state;

    const PlanText = [
      {
        name: "free",
        displayName: "免费",
        price: "$0.00",
        description: (
          <>
            免费适用于所有
            <br />
            在香港注册的慈善机构
          </>
        ),
        access: true,
        web: true,
        receipt: true,
        report: false,
        number: true,
        numberNote: "仅限快速付款",
        campaignDetails: null,
        creditCard: true,
        applePay: false,
        googlePay: false,
        recurringTransactions: false,
        PayMe: false,
        multipleLanguages: false,
        verifiedNonprofit: true,
        coverFees: true,
        landingPageCustomization: false,
        reducedTransactionFee: false,
        platformFee: "2%",
        manualPayments: false,
        customDomain: false,
        customInputFields: false,
        bgColor: "#93C7EA",
        txtColor: "#93C7EA",
      },
      {
        name: "plus",
        displayName: "Plus",
        price: (
          <>
            $459/月
            <br />
            <span style={{ fontSize: "12px", fontWeight: "400" }}>
              每月收费（按年结算）
            </span>
          </>
        ),
        description: "或 $550/月（按月收费）",
        access: true,
        web: true,
        receipt: true,
        report: true,
        number: true,
        numberNote: "最多 3 个",
        campaignDetails: "最多 3 个付款或捐款项目",
        creditCard: true,
        applePay: false,
        googlePay: false,
        recurringTransactions: false,
        PayMe: false,
        multipleLanguages: false,
        verifiedNonprofit: true,
        coverFees: true,
        landingPageCustomization: true,
        reducedTransactionFee: true,
        platformFee: "1%",
        manualPayments: false,
        customDomain: false,
        customInputFields: false,
        bgColor: "#1390E3",
        txtColor: "#1390E3",
      },
      {
        name: "pro",
        displayName: "Pro",
        price: (
          <>
            $792/月
            <br />
            <span style={{ fontSize: "12px", fontWeight: "400" }}>
              每月收费（按年结算）
            </span>
          </>
        ),
        description: "或 $950/月（按月收费）",
        access: true,
        web: true,
        receipt: true,
        report: true,
        number: true,
        numberNote: "最多 5 个",
        campaignDetails: "最多 5 个付款或捐款项目",
        creditCard: true,
        applePay: true,
        googlePay: true,
        recurringTransactions: true,
        PayMe: true,
        multipleLanguages: true,
        verifiedNonprofit: true,
        coverFees: true,
        landingPageCustomization: true,
        reducedTransactionFee: true,
        platformFee: "1%",
        manualPayments: false,
        customDomain: false,
        customInputFields: false,
        bgColor: "#0969AA",
        txtColor: "#0969AA",
      },
      {
        name: "premium",
        displayName: "Premium",
        price: (
          <>
            $1,250/月
            <br />
            <span style={{ fontSize: "12px", fontWeight: "400" }}>
              每月收费（按年结算）
            </span>
          </>
        ),
        description: "或 $1,500/月（按月收费）",
        access: true,
        web: true,
        receipt: true,
        report: true,
        number: true,
        numberNote: "无限",
        campaignDetails: "无上限付款或捐款项目",
        creditCard: true,
        applePay: true,
        googlePay: true,
        recurringTransactions: true,
        PayMe: true,
        multipleLanguages: true,
        verifiedNonprofit: true,
        coverFees: true,
        landingPageCustomization: true,
        reducedTransactionFee: true,
        platformFee: "1% 或 0.5%*",
        manualPayments: true,
        customDomain: true,
        customInputFields: true,
        bgColor:
          "linear-gradient(45deg, rgba(162,248,255,1) 0%, rgba(0,88,149,1) 100%)",
        txtColor: "#52A9CB",
      },
    ];

    const PLATFORM_FEE_DISCLAIMER =
      "*如过去 12 个月的交易额超过 HK$400,000";

    const featureCellStyle = {
      display: "flex",
      height: "75px",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    };

    const featureLabelItemStyle = {
      height: "75px",
      justifyContent: "end",
      alignItems: "center",
      color: "black",
      textAlign: "left",
      fontSize: "10pt",
    };

    const renderCheckIcon = (enabled) =>
      enabled ? (
        <div className="CnPricing-confirmFeature" alt="Confirm" />
      ) : (
        <div className="CnPricing-crossFeature" alt="Cross" />
      );

    const getPlanDisplayName = (plan) => plan.displayName;

    const compareRows = [
      {
        key: "plans",
        label: "方案",
        render: (plan) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <div
              className="CnPricing-planDot"
              style={{
                background: plan.bgColor,
              }}
            />
            <div
              className="CnPricing-planTxt"
              style={{
                color: plan.txtColor,
                fontWeight: "600",
              }}
            >
              {getPlanDisplayName(plan)}
            </div>
          </div>
        ),
      },
      {
        key: "verified-nonprofit",
        label:
          "列入 CheckPlus 已认证慈善团体名单（更多专属优惠即将推出！）",
        render: (plan) => renderCheckIcon(plan.verifiedNonprofit),
      },
      {
        key: "org-dashboard",
        label: "机构管理平台",
        render: (plan) => renderCheckIcon(plan.access),
      },
      {
        key: "items",
        label: "项目数量",
        render: (plan) =>
          plan.number ? (
            <div className="CnPricing-numberNote">{plan.numberNote}</div>
          ) : (
            renderCheckIcon(false)
          ),
      },
      {
        key: "automated-receipts",
        label: "自动发送付款及捐款收据",
        render: (plan) => renderCheckIcon(plan.receipt),
      },
      {
        key: "cover-fees",
        label: "捐款者可选择代付交易手续费",
        render: (plan) => renderCheckIcon(plan.coverFees),
      },
      {
        key: "landing-page",
        label: "建立捐款网页",
        render: (plan) => renderCheckIcon(plan.web),
      },
      {
        key: "landing-customisation",
        label: "自订捐款网页设计",
        render: (plan) => renderCheckIcon(plan.landingPageCustomization),
      },
      {
        key: "system-report",
        label: "建立平台报告",
        render: (plan) => renderCheckIcon(plan.report),
      },
      {
        key: "multiple-languages",
        label: "多种语言",
        render: (plan) => renderCheckIcon(plan.multipleLanguages),
      },
      {
        key: "recurring",
        label: "每月定期付款和捐款",
        render: (plan) => renderCheckIcon(plan.recurringTransactions),
      },
      {
        key: "manual-payments",
        label: "手动付款（例如支票、八达通、现金等）",
        render: (plan) => renderCheckIcon(plan.manualPayments),
      },
      {
        key: "custom-domains",
        label: "专属网域与电邮地址",
        render: (plan) => renderCheckIcon(plan.customDomain),
      },
      {
        key: "custom-inputs",
        label: "自订表格问题",
        render: (plan) => renderCheckIcon(plan.customInputFields),
      },
      {
        key: "payment-methods",
        label: "付款方式",
        isSectionHeader: true,
        render: () => null,
      },
      {
        key: "credit-card",
        label: "信用卡（通过 Stripe）Visa、Mastercard、AMEX、银联",
        render: (plan) => renderCheckIcon(plan.creditCard),
      },
      {
        key: "reduced-card-fee",
        label: "信用卡交易手续费减免",
        render: (plan) => renderCheckIcon(plan.reducedTransactionFee),
      },
      {
        key: "apple-pay",
        label: "Apple Pay",
        render: (plan) => renderCheckIcon(plan.applePay),
      },
      {
        key: "google-pay",
        label: "Google Pay",
        render: (plan) => renderCheckIcon(plan.googlePay),
      },
      {
        key: "payme",
        label: "PayMe",
        render: (plan) => renderCheckIcon(plan.PayMe),
      },
      {
        key: "platform-fee",
        label: "平台费",
        render: (plan) =>
          plan.platformFee ? (
            <div className="CnPricing-numberNote" style={{ textAlign: "center" }}>
              {plan.platformFee}
            </div>
          ) : (
            renderCheckIcon(false)
          ),
      },
    ];

    const renderPlanCell = (row, plan) =>
      row.isSectionHeader ? null : row.render(plan);

    const renderComparisonTable = (plans) => (
      <div className="CnPricing-featureContainer2">
        <div className="CnPricing-featureSet">
          {compareRows.map((row) => (
            <div
              style={{
                ...featureLabelItemStyle,
                fontWeight: row.isSectionHeader ? "600" : undefined,
              }}
              key={row.key}
            >
              <div
                className="CnPricing-featureText"
                style={row.isSectionHeader ? { textTransform: "uppercase" } : {}}
              >
                {row.label}
              </div>
            </div>
          ))}
        </div>

        {plans.map((plan, index) => (
          <div key={`${plan.name}-${index}`}>
            <div className="CnPricing-featureDescriptionRowBottom">
              {compareRows.map((row) => (
                <div style={featureCellStyle} key={row.key}>
                  {renderPlanCell(row, plan)}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );

    return (
      <div className="CnPricing-view">
        <Helmet>
          <title>订阅计划 - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuCn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="CnPricing-first">
          <div className="CnPricing-mainContainer">
            <div className="CnPricing-topContainer">
              <div className="CnPricing-heading">
                让您的非牟利机构更加高效，
                <br />
                您就可以做更有意义的事情。
              </div>

              <div className="CnPricing-comingSoon">
                <div className="CnPricing-comingText">全新订阅方案</div>
              </div>
            </div>

            <div className="CnPricing-featureContainer">
              <div className="CnPricing-extraSpace"></div>

              {PlanText.map((plan, key) => (
                <div
                  className="CnPricing-featureDescriptionColumn"
                  key={key}
                  style={{
                    position: "relative",
                    minHeight: "600px",
                    paddingBottom: "200px",
                    marginTop: "30px",
                    marginBottom: "30px",
                  }}
                >
                  <div
                    className="CnPricing-featureDescriptionRowTop"
                    style={{
                      background: plan.bgColor,
                    }}
                  >
                    <div className="CnPricing-planContainer">
                      <div className="CnPricing-planName">{plan.displayName}</div>

                      <div className="CnPricing-planPrice">{plan.price}</div>

                      <div className="CnPricing-planDescription">
                        {plan.description}
                      </div>
                    </div>
                  </div>
                  <div className="CnPricing-featureContainerRowBottom">
                    <Link to="/OrgSignup">
                      <div
                        className="CnPricing-getStarted"
                        style={{
                          background: plan.bgColor,
                        }}
                      >
                        立即申请
                      </div>
                    </Link>

                    {plan.name === "plus" ? (
                      <div className="CnPricing-everythingPlus">
                        包含“免费”方案的所有功能及以下新增功能。
                      </div>
                    ) : null}

                    {plan.name === "pro" ? (
                      <div className="CnPricing-everythingPlus">
                        包含“Plus”方案的所有功能及以下新增功能。
                      </div>
                    ) : null}

                    {plan.name === "premium" ? (
                      <div className="CnPricing-everythingPlus">
                        包含 Pro 方案的所有功能及以下新增功能。
                      </div>
                    ) : null}

                    {plan.name === "free" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">
                          建立网上账户
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">
                          建立付款和捐款网页
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">
                          收取付款和捐款
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">
                          自动发送付款及捐款收据
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">
                          支持以下由 Stripe 提供的付款方式
                          <p />

                          <strong>主要信用卡网络</strong>
                          <br />
                          - Visa
                          <br />
                          - MasterCard
                          <br />
                          - American Express
                          <br />
                          - UnionPay
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">
                          捐款者可选择代付交易手续费
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.campaignDetails ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">
                          {plan.campaignDetails}
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "pro" && plan.recurringTransactions ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">
                          每月定期付款和捐款
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.report && plan.name === "plus" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">
                          建立平台报告
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "plus" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">
                          自定义付款和捐款网页设计
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.reducedTransactionFee && plan.name === "plus" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">更优惠平台费用</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.applePay && plan.name !== "premium" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">Apple Pay</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.googlePay && plan.name !== "premium" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">Google Pay</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.recurringTransactions && plan.name === "plus" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">每月定期付款和捐款</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.PayMe && plan.name !== "premium" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">PayMe</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.multipleLanguages && plan.name !== "premium" ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">多种语言</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.customDomain ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">专属域名与邮箱</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.manualPayments ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">
                          手动支付处理（如八达通、现金等，无交易手续费）
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.customInputFields ? (
                      <div className="CnPricing-paymeFeature">
                        <div
                          className="CnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="CnPricing-featureTxt">自定义表格问题</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    <div
                      style={{
                        background: "white",
                        border: `2px solid ${plan.txtColor}`,
                        borderRadius: "15px",
                        padding: "20px",
                        textAlign: "center",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        width: "300px",
                        boxSizing: "border-box",
                        position: "absolute",
                        top: "710px",
                        left: "50%",
                        transform: "translateX(-50%)",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "14pt",
                          fontWeight: "600",
                          color: "#333",
                          marginBottom: "8px",
                        }}
                      >
                        平台费
                      </div>
                      <div
                        style={{
                          fontSize: "18pt",
                          fontWeight: "700",
                          color: plan.txtColor,
                        }}
                      >
                        {plan.platformFee}
                      </div>

                      {plan.name === "premium" ? (
                        <div
                          style={{
                            marginTop: "12px",
                            fontSize: "10pt",
                            fontWeight: "400",
                            color: "#666",
                            fontStyle: "italic",
                          }}
                        >
                          {PLATFORM_FEE_DISCLAIMER}
                        </div>
                      ) : null}

                      <div
                        style={{
                          marginTop: "15px",
                          paddingTop: "15px",
                          borderTop: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "12pt",
                            fontWeight: "600",
                            color: "#333",
                            marginBottom: "5px",
                          }}
                        >
                          交易手续费：
                        </div>
                        <div
                          style={{
                            fontSize: "11pt",
                            fontWeight: "400",
                            color: "#666",
                            fontStyle: "italic",
                          }}
                        >
                          由支付平台收取
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="CnPricing-extraSpace"></div>
            </div>

            <div className="CnPricing-topColumnRight"></div>

            <button
              type="button"
              className="CnPricing-compareButton"
              onClick={this.handleToggleComparison}
            >
              {isCompareExpanded ? "隐藏比较" : "比较所有计划"}
            </button>

            {isCompareExpanded && (
              <>
                {renderComparisonTable(PlanText)}

                <div
                  style={{
                    marginTop: "0px",
                    fontSize: "10pt",
                    color: "#666",
                    fontStyle: "italic",
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginBottom: "50px",
                  }}
                >
                  {PLATFORM_FEE_DISCLAIMER}
                </div>
              </>
            )}

            <div className="CnPricing-TransactionFeeContainer">
              <h1>交易手续费</h1>
            </div>

            <div className="CnPricing-gridBGTransactionFee">
              <div className="CnPricing-stripePaidContainer">
                <div className="CnPricing-hsbc">
                  <div className="CnPricing-stripeLogo" />
                  <div className="CnPricing-bar" />
                  <div className="CnPricing-hsbcDescription">交易手续费</div>
                </div>

                <div className="CnPricing-hsbcText">
                  <strong>本地 Visa/Mastercard</strong>
                  <br />
                  2.9% + HK$2.35

                  <p />
                  <strong>
                    本地 American Express
                  </strong>
                  <br />
                  3.4% + HK$2.35
                  <p />
                  <strong>所有國際卡</strong>
                  <br />
                  + 0.5% 國際卡
                </div>
              </div>
              <div className="CnPricing-hsbcContainer">
                <div className="CnPricing-hsbc">
                  <div className="CnPricing-hsbcLogo" />
                  <div className="CnPricing-bar" />
                  <div className="CnPricing-hsbcDescription">交易手续费</div>
                </div>

                <div className="CnPricing-hsbcText">
                  <strong>PayMe for Business</strong>
                  <br />
                  1.5%
                  <br />
                  费用由香港汇丰银行决定
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="CnPricing-referralContainer">
          <div className="CnPricing-referralWidth">
            <div className="CnPricing-heading">推荐计划</div>

            <div className="CnPricing-comingSoon">
              <div className="CnPricing-comingText">即将推出</div>
            </div>

            <div className="CnPricing-subHeading">
              每成功推荐 1 间机构即可获得 1 个月费用豁免*
              <p />
              <div className="CnPricing-subtitle">
                *请注意，当您推荐的非牟利机构成功注册服务后，您方可获得 1 个月费用豁免。推荐数量不限。
              </div>
            </div>
          </div>
        </div>

        <div className="CnPricing-footer">
          <div className="CnPricing-footerNav">
            <Link to="/CnTeam">
              <div className="CnPricing-footerNavItem">创办人的故事</div>
            </Link>
            <Link to="/CnFaq">
              <div className="CnPricing-footerNavItem">常见问题</div>
            </Link>
            <Link to="/CnContact">
              <div className="CnPricing-footerNavItem">联络我们</div>
            </Link>

            <Link to="/CnPrivacyPolicy">
              <div className="CnPricing-footerNavItem">私隐政策</div>
            </Link>

            <Link to="/CnTerms">
              <div className="CnPricing-footerNavItem">使用条款</div>
            </Link>
          </div>

          <div className="CnPricing-footer_text">
            香港九龙油塘四山街 11 号
            <br />
            华利工业大厦5楼A室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切权利。
          </div>
        </div>
      </div>
    );
  }
}

export default CnPricing;
